import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import ConsoleAPICard, { ConsoleAPICardProps } from "./Card/ConsoleAPICard";
import styles from "./ConsoleAPICards.module.scss";

type ConsoleAPICardsProps = {
	title?: string;
	cards: ConsoleAPICardProps[];
	className?: string;
};

const ConsoleAPICards = ({ title, cards, className }: ConsoleAPICardsProps) => {
	return (
		<Box className={styles.container} id="automotive">
			{title && <Typography className={styles.title}>{title}</Typography>}
			<Box className={clsx(styles.cards, className)}>
				{cards.map((card) => (
					<ConsoleAPICard {...card} />
				))}
			</Box>
		</Box>
	);
};

export default ConsoleAPICards;
